import moment from 'moment'
import {
  operatorByValue,
  stringOperators,
  notPublishedEnvObj,
  usersKey,
  languageKey,
  tagKey,
  workflowStageKey,
  uidKey,
  dateKey,
  contentTypeKey,
  termKey,
  environmentKey,
  commonQueryFormat,
  titleKey,
  urlKey,
  advSearchTextLabelKey,
  draftKey
} from '../constant'
// import {setCounterForAdvanceQuery} from '../helper'
import { allFieldsExceptUserDefined, getCtUserDefinedFields } from '../advanceQueryEntries'
import { fetchDataForQuery } from './QueryParser'

export const entriesQueryFormat = {
  locale: {
    key: [{ label: 'Language', value: 'locale' }],
    operator: [],
    value: [],
    queryType: 'languageLabel'
  },
  _content_type_uid: {
    key: [{ label: 'Content type', value: '_content_type_uid' }],
    operator: [],
    value: [],
    queryType: 'contentTypeLabel'
  },
  taxonomies: {
    key: [{ label: 'Taxonomy-Term', value: 'taxonomies' }],
    operator: [],
    value: [],
    queryType: 'taxonomyTermLabel'
  },
  tags: {
    key: [{ label: 'Tags', value: 'tags' }],
    operator: [],
    value: [],
    queryType: 'entriesTagLabel'
  },
  $localization: {
    key: [{ label: 'Localized In', value: '$localization' }],
    operator: [operatorByValue.$localization],
    value: [{ label: 'Any Locales', value: [{ label: 'Any Locales', value: '$any' }] }],
    queryType: 'localizedInLabel'
    // selectedLanguage: ''
  },
  _workflow: {
    key: [{ label: 'Workflow Stage', value: '_workflow' }],
    operator: [],
    value: [],
    queryType: 'workflowLabel'
  },

  //todo enable for title && URL
  url: {
    key: [{ label: 'URL', value: 'url' }],
    operator: [],
    value: [],
    queryType: 'systemDefUrlLabel'
  },
  title: {
    key: [{ label: 'Title', value: 'title' }],
    operator: [],
    value: [],
    queryType: 'systemDefTitleLabel'
  },
  ...commonQueryFormat
}

//in case of tags name and values are same
//in case of env name and values are same

const parseQueryForObject = ({
  queryKey,
  query,
  users,
  languages,
  queryArray,
  contentTypes,
  workflowStages,
  terms
}) => {
  try {
    console.log('parseQueryForObject -> queryKey', queryKey)
    if (queryKey === '$or' && Array.isArray(query['$or'])) {
      let notPubEnvCaseCheck = false
      let allEnvArray = []
      let notPubOperatorCheck

      const notPublishedArray = query['$or']
      notPublishedArray.forEach((query = {}) => {
        const pubQueryKey = (Object.keys(query) || [])[0]
        if (pubQueryKey === '_publish_details') {
          const { $exists } = query._publish_details || {}

          notPubOperatorCheck = $exists ? '$ne' : '$eq'

          notPubEnvCaseCheck = true
        } else if (pubQueryKey === '_publish_environment') {
          const valueArray = query[pubQueryKey]?.$in || []
          allEnvArray = [...allEnvArray, ...valueArray]
        }
      })

      if (notPubEnvCaseCheck) {
        const sampleQuery = entriesQueryFormat['_publish_environment']
        const rawQuery = {
          ...sampleQuery,
          operator: [operatorByValue[notPubOperatorCheck]],
          value: [notPublishedEnvObj]
        }
        queryArray.push(rawQuery)
      }

      if (Array.isArray(allEnvArray)) {
        allEnvArray.forEach((envValue) => {
          const sampleQuery = entriesQueryFormat['_publish_environment']
          const rawQuery = {
            ...sampleQuery,
            operator: [operatorByValue['$eq']],
            value: [{ label: envValue, envValue }]
          }
          queryArray.push(rawQuery)
        })
      }
    }

    // if (query && query[queryKey] && query[queryKey].$not) {
    //   query[queryKey].$not = { $regex: query[queryKey].$not }
    // }

    if (termKey === queryKey) {
      const { $in: matchTermsArray = [], $nin: notMatchTermsArray = [] } = query[queryKey]

      if (matchTermsArray.length || notMatchTermsArray.length) {
        let value = matchTermsArray[0] || notMatchTermsArray[0]

        const operator = Object.keys(query[queryKey])[0]
        const foundTerm = terms.find((term) => term.term_uid === value.term_uid)
        const sampleQuery = entriesQueryFormat[queryKey]

        const rawQuery = {
          ...sampleQuery,
          operator: [operatorByValue[operator]],
          value: [{ label: foundTerm && foundTerm.label ? foundTerm.label : value.term_uid, value: [value] }]
        }
        queryArray.push(rawQuery)
      }
    }

    if (usersKey.includes(queryKey)) {
      const value = Object.values(query[queryKey])[0]
      const operator = Object.keys(query[queryKey])[0]

      const foundUser = users.find((user) => user.value === value)
      const sampleQuery = entriesQueryFormat[queryKey]

      const rawQuery = {
        ...sampleQuery,
        operator: [operatorByValue[operator]],
        value: [{ label: foundUser ? foundUser.label : value, value }]
      }
      queryArray.push(rawQuery)
    }

    if (advSearchTextLabelKey === queryKey) {
      const value = Object.values(query[queryKey])[0]
      const operator = Object.keys(query[queryKey])[0]
      const sampleQuery = commonQueryFormat[queryKey]
      const rawQuery = {
        ...sampleQuery,
        operator: [operatorByValue[operator]],
        value: [{ label: value, value }]
      }
      queryArray.push(rawQuery)
    }

    if (languageKey === queryKey) {
      const value = Object.values(query[queryKey])[0]
      const operator = Object.keys(query[queryKey])[0]
      const allLangOpt = { label: 'All Languages', value: '$allLanguages' }

      const foundLanguage = value === allLangOpt.value ? allLangOpt : languages.find((lang) => lang.value === value)
      const sampleQuery = entriesQueryFormat[queryKey]
      const rawQuery = {
        ...sampleQuery,
        operator: [operatorByValue[operator]],
        value: [{ label: foundLanguage ? foundLanguage.label : value, value }]
      }

      queryArray.push(rawQuery)

      const selectedLanguage = value
      if (query.locale['$localization'] && typeof query.locale['$localization'] === 'object') {
        const localizeQuery = query.locale['$localization']
        const operator = Object.keys(localizeQuery)[0]

        const operatorObj = {
          $in: '$localization',
          $nin: '$notLocalization'
        }
        const evaluateOperator = operatorObj[operator]

        const value: any = Object.values(localizeQuery)[0]

        let localizedValue = []

        value.forEach((localize) => {
          const foundLanguage = languages.find((lang) => lang.value === localize) || {
            label: localize,
            value: localize
          }
          localizedValue.push(foundLanguage)
        })

        const label = localizedValue.length === 1 ? localizedValue[0].label : `${localizedValue.length} Selected`

        const sampleLocalizeQuery = entriesQueryFormat['$localization']
        const rawQuery = {
          ...sampleLocalizeQuery,
          operator: [operatorByValue[evaluateOperator]],
          value: [{ label, value: localizedValue }],
          selectedLanguage
        }
        queryArray.push(rawQuery)
      } else if (value !== '$allLanguages') {
        const sampleLocalizeQuery = entriesQueryFormat['$localization']
        queryArray.push({ ...sampleLocalizeQuery, selectedLanguage })
      }
    }

    if (tagKey === queryKey) {
      const value = Object.values(query[queryKey])[0]
      const operator = Object.keys(query[queryKey])[0]

      // DONT REMOVE THIS, this is commented for SEPT 11 release
      // null not null check
      if (operator === '$exists' && typeof value === 'boolean') {
        const sampleQuery = entriesQueryFormat[queryKey]
        let existsOperator = operatorByValue[operator]
        existsOperator.label = value ? 'Is not empty' : 'Is empty'
        const rawQuery = {
          ...sampleQuery,
          operator: [existsOperator],
          value: [{ label: '', value }]
        }
        queryArray.push(rawQuery)
      } else if (Array.isArray(value) && value.length) {
        value.forEach((singleTagValue) => {
          const operator = Object.keys(query[queryKey])[0]
          const sampleQuery = entriesQueryFormat[queryKey]
          const rawQuery = {
            ...sampleQuery,
            operator: [operatorByValue[operator]],
            value: [{ label: singleTagValue, value: singleTagValue }]
          }
          queryArray.push(rawQuery)
        })
      } else {
        const operator = Object.keys(query[queryKey])[0]
        const sampleQuery = entriesQueryFormat[queryKey]
        const rawQuery = {
          ...sampleQuery,
          operator: [operatorByValue[operator]],
          value: [{ label: value, value }]
        }
        queryArray.push(rawQuery)
      }
    }

    if (workflowStageKey === queryKey) {
      const value = Object.values(query[queryKey])[0]
      if (Array.isArray(value) && value.length) {
        value.forEach((singleStageValue) => {
          const operator = Object.keys(query[queryKey])[0]
          const sampleQuery = entriesQueryFormat[queryKey]

          let workflowStageLabel = singleStageValue
          const foundStages = workflowStages.find((stage) => stage.value === singleStageValue)
          workflowStageLabel = foundStages ? foundStages.label : singleStageValue

          const rawQuery = {
            ...sampleQuery,
            operator: [operatorByValue[operator]],
            value: [{ label: workflowStageLabel, value: singleStageValue }]
          }
          queryArray.push(rawQuery)
        })
      } else {
        const operator = Object.keys(query[queryKey])[0]
        const sampleQuery = entriesQueryFormat[queryKey]

        let workflowStageLabel = value
        const foundStages = workflowStages.find((stage) => stage.value === value)
        workflowStageLabel = foundStages ? foundStages.label : value

        const rawQuery = {
          ...sampleQuery,
          operator: [operatorByValue[operator]],
          value: [{ label: workflowStageLabel, value }]
        }
        queryArray.push(rawQuery)
      }
    }

    if (uidKey === queryKey) {
      const value = Object.values(query[queryKey])[0]
      const operator = Object.keys(query[queryKey])[0]
      const sampleQuery = entriesQueryFormat[queryKey]
      const rawQuery = {
        ...sampleQuery,
        operator: [operatorByValue[operator]],
        value: [{ label: value, value, type: 'text' }]
      }
      queryArray.push(rawQuery)
    }

    if (draftKey === queryKey) {
      const value = Object.values(query[queryKey])[0]
      const operator = Object.keys(query[queryKey])[0]
      const sampleQuery = commonQueryFormat[queryKey]
      
      const normalizedValue = value === true || value === 'true'
      const valueLabel = normalizedValue ? 'true' : 'false'
      
      const rawQuery = {
        ...sampleQuery,
        operator: [operatorByValue[operator]],
        value: [{ label: valueLabel, value: normalizedValue }]
      }
      queryArray.push(rawQuery)
    }
    //todo handle equal case
    if (dateKey.includes(queryKey)) {
      const value = Object.values(query[queryKey])[0]
      const operator = Object.keys(query[queryKey])[0]

      // DONT REMOVE THIS, this is commented for SEPT 11 release
      // null not null check
      if (operator === '$exists' && typeof value === 'boolean') {
        const sampleQuery = entriesQueryFormat[queryKey]
        let existsOperator = operatorByValue[operator]
        existsOperator.label = value ? 'Is not empty' : 'Is empty'
        const rawQuery = {
          ...sampleQuery,
          operator: [existsOperator],
          value: [{ label: '', value }]
        }
        queryArray.push(rawQuery)
      }

      const sampleQuery = entriesQueryFormat[queryKey]
      const localDate = moment(value).format('YYYY-MM-DD')
      const controlledOp = operator === '$eq' ? { label: 'Equals', value: '$eq' } : operatorByValue[operator]
      const rawQuery = {
        ...sampleQuery,
        operator: [controlledOp],
        value: [{ label: localDate, value: localDate }]
      }
      queryArray.push(rawQuery)
    }

    if (contentTypeKey === queryKey) {
      const value: any = Object.values(query[queryKey])[0] || ' '
      const operator = Object.keys(query[queryKey])[0]
      // console.log('contentTypeKey -> value,  operator', value, operator)
      const sampleQuery = entriesQueryFormat[queryKey]

      let foundContentType = contentTypes.find((ct) => ct.value === value)

      let parsedValue: any
      if (foundContentType) {
        parsedValue = [{ label: foundContentType.label, value }]
      } else {
        parsedValue = [{ label: value, value, type: 'text' }]
      }
      const rawQuery = {
        ...sampleQuery,
        operator: [operatorByValue[operator]],
        value: parsedValue
      }
      queryArray.push(rawQuery)

      // foundContentType = foundContentType || {}
      // if (operator === '$regex') {
      //   const actualValue = value.split('.*')[1]
      //   const rawQuery = {
      //     ...sampleQuery,
      //     operator: [operatorByValue.contains],
      //     value: [{ label: actualValue, value: actualValue, type: 'text' }]
      //   }
      //   queryArray.push(rawQuery)
      // } else {

      // }
    }

    if (environmentKey.includes(queryKey)) {
      const valueArray: any = Object.values(query[queryKey])[0]

      if (Array.isArray(valueArray)) {
        valueArray.forEach((envValue) => {
          const operator = Object.keys(query[queryKey])[0]
          const sampleQuery = entriesQueryFormat[queryKey]
          const rawQuery = {
            ...sampleQuery,
            operator: [operatorByValue[operator]],
            value: [{ label: envValue, value: envValue }]
          }
          queryArray.push(rawQuery)
        })
      }
    }

    if ([urlKey, titleKey].includes(queryKey)) {
      let operator = Object.keys(query[queryKey])[0]

      const value = Object.values(query[queryKey])[0] || ' '
      const sampleQuery = entriesQueryFormat[queryKey]

      let evalOp = operatorByValue[operator]
      let evalValue = { label: value, value: value }

      // DONT REMOVE THIS, this is commented for SEPT 11 release
      // null not null check
      if (operator === '$exists') {
        let valueForNullNotNull = Object.values(query[queryKey])[0]
        evalOp = { ...evalOp, label: valueForNullNotNull ? 'Is not empty' : 'Is empty' }
        evalValue = { value: valueForNullNotNull, label: '' }
      }
      const rawQuery = {
        ...sampleQuery,
        operator: [evalOp],
        value: [evalValue]
      }
      queryArray.push(rawQuery)
      return
    }
  } catch (error) {
    console.log('parseQueryForObject error', error)
  }
}

const entriesFormat = {
  key: [
    {
      label: 'Text',
      value: '_text_entries'
    }
  ],
  operator: [
    {
      name: 'Contains',
      icon: 'Contains',
      value: 'contains'
    }
  ],
  value: [
    {
      label: 'test',
      value: 'test',
      type: 'text'
    }
  ],
  isQueryCompleted: true,
  queryType: 'inEntries',
  nextQuery: 'inEntries'
}

//handle regex another patern regex:value
//hanlde operator equeal case
export const queryParserEntries = async (queryObject, search_text, fetchData, cacheResponse?) => {
  try {
    let queryArray = []

    const { $and } = queryObject || {}
    const andArray = $and

    // if (search_text) {
    //   queryArray.push({
    //     ...entriesFormat,
    //     value: [{ label: search_text, value: search_text, type: 'text' }]
    //   })
    // }

    if (!queryObject || !Array.isArray(andArray)) {
      return queryArray
    }

    let userResponse = []
    let langResponse = []
    let ctResponse = []
    let workflowStagesResponse = []
    let termsResponse = []

    if (cacheResponse) {
      userResponse = cacheResponse.userResponse
      langResponse = cacheResponse.langResponse
      ctResponse = cacheResponse.ctResponse
      workflowStagesResponse = cacheResponse.workflowStagesResponse
      termsResponse = cacheResponse.termsResponse
    } else {
      const response = await fetchDataForQuery(andArray, fetchData)
      userResponse = response.userResponse
      langResponse = response.langResponse
      ctResponse = response.ctResponse
      workflowStagesResponse = response.workflowStagesResponse
      termsResponse = response.termsResponse
    }

    for (let query of andArray) {
      const queryKey = Object.keys(query)[0]
      parseQueryForObject({
        queryKey,
        query,
        users: userResponse,
        languages: langResponse,
        queryArray,
        contentTypes: ctResponse,
        workflowStages: workflowStagesResponse,
        terms: termsResponse
      })
    }

    return queryArray
  } catch (error) {
    console.log('queryParserEntries', error)
    throw error
  }
}

const parsedWorkFlowQueryObject = (workflowQueryObjectArray, cacheResponse) => {
  const workflowStagesResponse = cacheResponse.workflowStagesResponse || []

  const key = { label: 'Workflow Stage', value: '_workflow' }
  const queryType = 'workflowLabel'
  const nextQuery = 'inWorkflow'
  let queryArray = []
  workflowQueryObjectArray.forEach((query) => {
    const queryKey = Object.keys(query)[0]
    const value = Object.values(query[queryKey])[0]
    const operator = Object.keys(query[queryKey])[0]

    let workflowStageLabel = value
    let valueOptions = workflowStagesResponse

    const foundStages = workflowStagesResponse.find((stage) => stage.value === value)

    if (foundStages) {
      workflowStageLabel = foundStages.label
      valueOptions = workflowStagesResponse.filter((stage) => stage.workflowUid === foundStages.workflowUid)
    }

    queryArray.push({
      key: [{ ...key, valueOptions }],
      operator: [operatorByValue[operator]],
      value: [{ label: workflowStageLabel, value }],
      isQueryCompleted: true,
      queryType,
      nextQuery
    })
  })
  return queryArray
}

const getUserDefinedQueryValue = async (query, value, queryType, fetchData) => {
  try {
    let formattedValue: any = [{ label: value, value }]
    if (queryType === 'dateLabel') {
      const localDate = moment(value).format('YYYY-MM-DD')
      formattedValue = [{ label: localDate, value: localDate }]
    }

    if (queryType === 'referenceLabel' && query.contentTypeUid) {
      const response = await fetchData.fetchEntryByUid({ contentTypeUid: query.contentTypeUid, entryUid: value })
      formattedValue = [{ label: response.title || value, value, ctUid: query.contentTypeUid }]
    }

    if (queryType === 'fileLabel') {
      const response = await fetchData.fetchAssets({ assetUid: value })
      const assetLabel = (response.data[0] && response.data[0].label) || value
      formattedValue = [{ label: assetLabel, value }]
    }

    return formattedValue
  } catch (error) {
    throw error
  }
}

const getUserDefinedQueryByQueryKey = async (query, userDefinedFields, fetchData) => {
  try {
    const queryKey = Object.keys(query)[0]
    const value = Object.values(query[queryKey])[0]
    const operator = Object.keys(query[queryKey])[0]

    for (let suggestion of userDefinedFields) {
      const foundSuggestionOptIndex = suggestion.options.findIndex((option) => option.value === queryKey)
      if (foundSuggestionOptIndex !== -1) {
        const formattedValue = await getUserDefinedQueryValue(query, value, suggestion.queryType, fetchData)
        let formattedQuery = {
          key: [suggestion.options[foundSuggestionOptIndex]],
          operator: [operatorByValue[operator]],
          value: formattedValue,
          // isQueryCompleted: true,
          queryType: suggestion.queryType
          // nextQuery: suggestion.nextQuery
        }

        // DONT REMOVE THIS, this is commented for SEPT 11 release
        // null not null check
        console.log('check user defined query', query, operator, value)
        if (operator === '$exists' && typeof value === 'boolean') {
          let existsOperator = operatorByValue[operator]
          existsOperator.label = value ? 'Is not empty' : 'Is empty'

          formattedQuery.operator = [existsOperator]
          formattedQuery.value = [{ label: '', value }]
        }

        return formattedQuery
      }
    }
  } catch (error) {
    throw error
  }
}

const parsedUserdefinedQueryObject = async (ctSchema, userdefinedQueryObjectArray, fetchData) => {
  try {
    const userDefinedFields = getCtUserDefinedFields(ctSchema, [], '', '')

    let queryArray = []
    for (let query of userdefinedQueryObjectArray) {
      const parsedQuery = await getUserDefinedQueryByQueryKey(query, userDefinedFields, fetchData)
      if (parsedQuery) {
        queryArray.push(parsedQuery)
      }
    }
    return queryArray
  } catch (error) {
    console.log('parsedUserdefinedQueryObject', error)
    throw error
  }
}

const checkSelectedContentType = (currentQueryObjectArray) => {
  const ctQueries = currentQueryObjectArray.filter((query) => Object.keys(query)[0] === '_content_type_uid')

  if (ctQueries.length) {
    if (ctQueries.length === 1) {
      return {
        isMulti: false,
        ct_Uid: Object.values(ctQueries[0]._content_type_uid)[0]
      }
    } else {
      const ctUids = ctQueries.map((ct) => Object.values(ct._content_type_uid)[0])

      return {
        isMulti: true,
        ct_Uid: ctUids
      }
    }
  }
  return
}

const isNotPubQuery = (eachQuery = {}) => {
  try {
    const { $or: orArray = [] }: any = eachQuery
    const stringiFiedEachQuery = JSON.stringify(eachQuery)

    if (orArray.length && stringiFiedEachQuery.includes('_publish_details')) {
      return true
    }
    return false
  } catch (error) {
    return false
  }
}

export const advanceQueryParserForEntries = async (
  queryObject,
  cacheResponse,
  fetchData,
  selectedCtStatus = null,
  isRoot = true
) => {
  try {
    const parentMatchOperator = Object.keys(queryObject)[0]
    const currentQueryObjectArray = queryObject[parentMatchOperator]

    const matchoperator = ['$and', '$or']

    let childQueryArray = []
    let currentSyntaxQueryObjectArray = []
    let userdefinedQueryObjectArray = []
    let workflowQueryObjectArray = []
    let children = []

    //todo test selected `ctStatus` when duplicate cases fixes
    const selectedCtResponse = checkSelectedContentType(currentQueryObjectArray)
    if (selectedCtResponse) {
      selectedCtStatus = selectedCtResponse
    }

    if (matchoperator.includes(parentMatchOperator)) {
      currentQueryObjectArray.forEach((query) => {
        // console.log("🚀 ~ currentQueryObjectArray.forEach ~ query:", query)

        if (allFieldsExceptUserDefined.includes(Object.keys(query)[0]) || isNotPubQuery(query)) {
          //push all syntax query Object
          currentSyntaxQueryObjectArray.push(query)
        } else if (matchoperator.includes(Object.keys(query)[0])) {
          //push all and/or query object
          childQueryArray.push(query)
        } else if (Object.keys(query)[0] === '_workflow') {
          //workflow case
          workflowQueryObjectArray.push(query)
        } else {
          //all userdefined case
          userdefinedQueryObjectArray.push(query)
        }
      })
    }

    //parsed userdefined query
    let userDefinedQueryArray = []
    let workflowQueryArray = []
    if (selectedCtStatus && !selectedCtStatus.isMulti && userdefinedQueryObjectArray.length) {
      const singleCtResponse = await fetchData.fetchSingleContentType(selectedCtStatus.ct_Uid)
      userDefinedQueryArray = await parsedUserdefinedQueryObject(
        singleCtResponse.content_type.schema,
        userdefinedQueryObjectArray,
        fetchData
      )
    }

    if (workflowQueryObjectArray.length) {
      workflowQueryArray = parsedWorkFlowQueryObject(workflowQueryObjectArray, cacheResponse)
      // const selectedCtUid = selectedCtStatus.isMulti ? selectedCtStatus.ct_Uid : [selectedCtStatus.ct_Uid]
      // const response = await fetchData.fetchWorkflowByCtUids(selectedCtUid)
    }

    const currentQuery = { $and: currentSyntaxQueryObjectArray }
    let queryArray = await queryParserEntries(currentQuery, '', fetchData, cacheResponse)
    for (let subQuery of childQueryArray) {
      const parsedQuery = await advanceQueryParserForEntries(
        subQuery,
        cacheResponse,
        fetchData,
        selectedCtStatus,
        false
      )

      if (parsedQuery) {
        children.push(parsedQuery)
      }
    }

    const data: any = {}
    if (isRoot) data.root = true
    data.children = children
    data.queryArray = [...queryArray, ...userDefinedQueryArray, ...workflowQueryArray]
    data.queryType = parentMatchOperator === '$and' ? 'matchAll' : 'matchAny'
    return data
  } catch (error) {
    console.log('advanceQueryParserForEntries error', error)
    throw error
  }
}
